import { makeStyles } from '@vakantiesnl/components/src/styles/themes/themewrapper';

export const useCustomStyles = makeStyles()((theme) => ({
	elementContainer: {
		maxWidth: 1200,
		padding: `0 ${theme.spacing.small}`,
		marginLeft: 'auto',
		marginRight: 'auto',
	},
}));
